export function copyToClipboard(text: string): boolean {
  if (!text) return false;

  // Modern browsers
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .catch(err => console.error('Copy failed:', err));
    return true;
  }

  // Fallback for old browsers (IE, older Safari, etc.)
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';

  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand('copy');
    document.body.removeChild(textArea);
    return true;
  } catch (err) {
    console.error('Copy failed:', err);
    document.body.removeChild(textArea);
    return false;
  }
}